import { getEventTimestamp } from "v2/helpers/timeline";

export const sortIncidentsByMostRecentUpdate = (incidents) => {
  return [...incidents].sort((a, b) => {
    const aTime = (a.timeline && a.timeline.length) ? getEventTimestamp(a.timeline[0]) : a.timestamps.started;
    const bTime = (b.timeline && b.timeline.length) ? getEventTimestamp(b.timeline[0]) : b.timestamps.started;
    return new Date(bTime) - new Date(aTime);
  });
};